// i18n area 'cluster' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.hy-AM.meta.json.
import type { enUS } from './cluster'

export const hyAM: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Երաշխիքային մուտքեր',
      subtitle: 'Հանգույցի սպասարկման դուռը՝ միայն կարդալու մուտքը ժամանակավոր գաղտնաբառով և արտակարգ հաշիվը չհրկիզվող պահարանի գաղտնաբառով',
      readOnlyTitle: 'Միայն կարդալու մուտք (trantor)',
      stateNone: 'փակ',
      stateGranted: 'բաց',
      stateGrantedPending: 'տրված — կիրառվում է հանգույցում',
      grantedBy: 'Տրվել է',
      grantedAt: 'Տրման ամսաթիվ',
      expiresAt: 'Սպառվում է',
      reason: 'Պատճառ',
      endedAt: 'Փակ',
      endedReason: {
        revoked: 'հետ է կանչվել',
        expired: 'սպառվել է (TTL)',
        reboot: 'հանգույցի վերագործարկում',
        failed: 'չի կիրառվել (առաջադրանքը ձախողվեց)'
      },
      grant: 'Տալ միայն կարդալու մուտք…',
      grantTitle: 'Տալ միայն կարդալու մուտք',
      grantSubmit: 'Տալ',
      grantError: 'Տրամադրումը մերժվեց',
      grantConfirm: 'TVirt-ը ստեղծում է ժամանակավոր գաղտնաբառ «trantor» համակարգային օգտատիրոջ համար (միայն կարդալ՝ journal և ախտորոշում, առանց sudo) և առաջադրանքով սահմանում է այն հանգույցում։ Գաղտնաբառը ցուցադրվում է ՄԻԱՅՆ մեկ անգամ՝ հաստատման պահին. այն դադարում է ժամկետի սպառման, հետ կանչման կամ հանգույցի հաջորդ վերագործարկման դեպքում։',
      reasonLabel: 'Պատճառ',
      reasonHint: 'Ինչու եք բացում դուռը՝ մնում է տրամադրման, աուդիտի և մատյանի մեջ',
      ttlLabel: 'Տևողություն',
      ttlHours: '{n} ժ',
      revoke: 'Հետ կանչել միայն կարդալու մուտքը…',
      revokeTitle: 'Հետ կանչել միայն կարդալու մուտքը',
      revokeSubmit: 'Հետ կանչել',
      revokeError: 'Հետ կանչումը մերժվեց',
      revokeConfirm: 'Տրամադրումն անմիջապես ավարտվում է, և առաջադրանքը կրկին արգելափակում է «trantor» օգտատիրոջը հանգույցում. ժամանակավոր գաղտնաբառը դադարում է գործել։',
      passwordTitle: 'Միայն կարդալու գաղտնաբառ',
      passwordOnce: 'Այս գաղտնաբառը ցուցադրվում է ՄԻԱՅՆ մեկ անգամ. պատճենեք հիմա։ Այն ոչ մի տեղ չի պահվում և կրկին կարդալ հնարավոր չի լինի. եթե կորցնեք, տրամադրեք նորից։',
      passwordUser: 'Օգտատեր',
      passwordLabel: 'Գաղտնաբառ',
      passwordHint: 'Վավեր է մինչև {until} կամ մինչև հանգույցի հաջորդ վերագործարկումը. կիրառելի է, երբ տրամադրման առաջադրանքն ավարտված է։ Մուտք՝ ssh trantor@<հանգույցի հասցե>։',
      emergencyTitle: 'Վերջին արտակարգ մուտք (trantor-emergency)',
      lastLogin: '{time}՝ {via} միջոցով, {from}-ից',
      lastLoginNone: 'չի դիտարկվել',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'վահանակ',
        sudo: 'sudo',
        unknown: 'անհայտ'
      },
      emergencyHint: '«trantor-emergency» արտակարգ հաշիվը (լիարժեք sudo) միշտ միացված է հանգույցի տեղադրման ժամանակ ստեղծված և պահարանում պահվող գաղտնաբառով. TVirt-ը այն չգիտի, չի փոխում և չի վերականգնում։ Յուրաքանչյուր մուտք զեկուցվում է այստեղ և իրադարձությունների մատյանում։'
    },
    nodeFirewall: {
      tab: 'Ֆայրվոլ',
      title: 'Հանգույցների ֆայրվոլ',
      subtitle: 'Այն nftables ruleset-ի դիրքորոշումը, որն ամեն հանգույց կիրառում է իր վրա — հանգույցի միակ ֆայրվոլը (firewalld-ն անջատված է)',
      modeLabel: 'Դիրքորոշում',
      mode: {
        disabled: 'Անջատված — հանգույցների վրա ruleset չկա',
        permissive: 'Թույլատրող — հաշվում և գրանցում է, ոչինչ դեն չի նետում',
        enforced: 'Կիրառված — ներս է մտնում միայն ածանցյալ ռեգիստրը'
      },
      hint: {
        disabled: 'Ինչպես այսօր է. հանգույցները ոչ մի ruleset չեն կրում։ Անցեք թույլատրողի՝ ԿԱՐԴԱԼՈՒ, թե ինչ դեն կնետվեր, նախքան այն դեն նետվի։',
        permissive: 'Ամեն հանգույց իր ածանցյալ ruleset-ը կիրառում է policy accept-ով. այն, ինչ կիրառված ռեժիմը դեն կնետեր, հաշվվում և գրանցվում է (journal-ի նախածանց «tvirt-node would-drop:»)։ Ոչինչ չի արգելափակվում։',
        enforced: 'Ամեն հանգույց իր ածանցյալ ruleset-ը կիրառում է policy drop-ով. ssh և API ամենուրից, store / live migration / overlay / Ceph միայն անդամներից, ցանցային ծառայությունների listener-ները՝ սպասարկվող ցանցից։ Ամեն փոփոխություն հաստատման apply է — հանգույցը, որը չի կարողանում հաստատել, ինքն է հետ գնում։'
      },
      confirmTitle: 'Կիրառե՞լ հանգույցների ֆայրվոլը',
      confirmBody: 'Ամեն հանգույց ruleset-ը կիրառում է հաստատմամբ. վերջնաժամկետի ընթացքում նոր կանոնների միջով ստուգում է backend-ը, store-ը և ssh-ը և հաստատում — հակառակ դեպքում ինքն է հետ գնում նախորդ ruleset-ին։ Նախ կարդացեք թույլատրող ռեժիմի հաշվիչները հանգույցների վրա։',
      confirmSubmit: 'Կիրառել',
      confirmCancel: 'Չեղարկել',
      lensTitle: 'Հանգույցի ֆայրվոլ',
      loadError: 'Չհաջողվեց բեռնել հանգույցի ֆայրվոլի ոսպնյակը',
      noReport: 'Այս հանգույցից դեռ ֆայրվոլի զեկույց չկա — worker-ը կզեկուցի հաջորդ անցման ժամանակ',
      firewalldActive: 'Այս հանգույցի վրա աշխատում է firewalld. հանգույցի ֆայրվոլը հրաժարվում է կիրառվել նրա կողքին (mask արեք firewalld-ն)',
      conditionUnconfirmed: 'Դեռ հաստատված ruleset չկա — հանգույցը բաց է',
      conditionRolledBack: 'Վերջին apply-ը հետ գնաց — նույն սերունդը նորից չի փորձվում, քանի դեռ ռեգիստրը չի փոխվել կամ դիրքորոշումը նորից չի փոխվել',
      lastError: 'Վերջին սխալ',
      posture: 'Դիրքորոշում',
      observedAt: 'Դիտարկված',
      desiredGeneration: 'Ցանկալի սերունդ',
      componentTitle: 'Հանգույցի բաղադրիչ',
      componentSubtitle: 'tvirt-node-firewall — բեռնման ժամանակ կիրառում է հաստատված ruleset-ը, չհաստատվածն ինքն է հետ բերում',
      componentAbsent: 'Բաղադրիչը դեռ չի զեկուցել',
      phase: 'Փուլ',
      phases: {
        none: 'Երբեք չի կիրառվել',
        applied: 'Կիրառված — սպասում է հաստատման',
        confirmed: 'Հաստատված',
        rolledBack: 'Հետ գնացած'
      },
      generation: 'Սերունդ',
      appliedAt: 'Կիրառվել է',
      confirmedAt: 'Հաստատվել է',
      deadline: 'Rollback-ի վերջնաժամկետ',
      lastRollback: 'Վերջին rollback',
      registryTitle: 'Ածանցյալ ռեգիստր',
      registrySubtitle: 'Պորտերը, որոնք այս հանգույցը բացում է՝ ըստ դասի և ծագման — ածանցված կլաստերից, երբեք ձեռքով չխմբագրված',
      registryEmpty: 'Ոչինչ ածանցված չէ — դիրքորոշումն անջատված է առանց հաստատված ruleset-ի, կամ դեռ զեկույց չկա',
      colClass: 'Դաս',
      colPort: 'Պորտ',
      colSource: 'Աղբյուր',
      colOrigin: 'Ծագում',
      classes: {
        public: 'Հանրային',
        internode: 'Միջհանգուցային',
        tenant: 'Tenant'
      },
      sourceMembers: 'միայն անդամները',
      sourceAnywhere: 'ամենուրից',
      sourceBridge: '{iface}-ի վրա'
    },
    derivationDerived: 'ածանցյալ',
    derivationDiverged: 'շեղված',
    derivationDerivedTip: 'Ցանցային փաստաթուղթը ԱԾԱՆՑՎԱԾ Է {fabric} fabric-ից և դեռ համընկնում է render-ի հետ ընթացիկ մուտքերի վրա — սեղմեք ածանցման պլանի համար։',
    derivationDivergedTip: '{fabric} fabric-ից ածանցումը փոխվել է վերջին apply-ից հետո (fabric, մալուխավորում, դերեր կամ հղումներ) — սեղմեք սպասվող diff-ի համար։',
    derivationRetiring: {
      one: '{n} հասցե դատարկվում է',
      other: '{n} հասցե դատարկվում է'
    },
    standaloneHint: 'Այս հանգույցը կլաստեր չունի. այն դեռ տեղադրված չէ։ Կլաստերները ստեղծվում են ԿԱՄ միանում են տեղադրման ժամանակ — անդամի Սերվերներ աղյուսակից գեներացված միանալու թոքենը տրվում է տեղադրիչին (dev՝ db:init-cluster / db:init-join)։',
    reducedHint: 'Ձեր թույլտվությունները ծածկում են սկոուպ, ոչ ամբողջ կլաստերը. նավատորմի գույքացուցակը — հանգույցներ, կարգավորումներ և սարքեր — տեսանելի է միայն կլաստերի ադմինիստրատորներին։',
    phaseReady: 'Պատրաստ',
    phaseForming: 'Ձևավորվում է',
    storeMembers: 'Store-ի անդամներ',
    watermark: 'Զուգամիտման շեմ',
    configGeneration: 'Կոնֆիգուրացիայի սերունդ',
    converged: 'զուգամիտված',
    behind: 'հետ է — {m} / {n}',
    revision: 'Ռևիզիա',
    rolesTitle: 'Ցանցային դերեր',
    rolesSubtitle: 'Հասցեներ ըստ անդամի՝ ամեն թրաֆիկի դասի համար — կապն ինքը ապրում է հոսթի ցանցում',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'ժառանգում է management-ը',
    settingsTitle: 'Կարգավորումներ',
    settingsSubtitle: 'Անվտանգության քաղաքականություն կլաստերի մակարդակով — գնահատվում է ամեն հանգույցի կողմից՝ իր լոկալ ռեպլիկայից',
    taskRetentionTitle: 'Առաջադրանքների պահպանում',
    taskRetentionSubtitle: 'Միասնական GC բոլոր առաջադրանքների համար — տարիքը կամ առաստաղը գերազանցած ավարտված առաջադրանքները հավաքվում են, ընթացիկները՝ երբեք',
    taskRetentionMaxAge: 'Առավելագույն տարիք (օր)',
    taskRetentionMaxCount: 'Պահվող առաջադրանքների առավելագույն թիվը',
    eventRetentionTitle: 'Իրադարձությունների պահպանում',
    eventRetentionSubtitle: 'Մատյանի GC-ն. առաջադրանքներից անկախ քաղաքականություն. առաջադրանքը հերթ է, իրադարձությունը՝ հիշողություն',
    eventRetentionMaxAge: 'Առավելագույն տարիք (օր)',
    eventRetentionMaxCount: 'Պահվող իրադարձությունների առավելագույն թիվ',
    spaceThresholdsTitle: 'Տարածքի շեմեր',
    spaceThresholdsSubtitle: 'Երբ լցվող պահեստը հայտնվում է մատյանում (և ծանուցումներում)',
    spaceLowPct: 'Զգուշացում սկսած (% օգտագործված)',
    spaceCriticalPct: 'Կրիտիկական սկսած (% օգտագործված)',
    spaceOrderError: 'Կրիտիկականը չի կարող լինել զգուշացումից ցածր',
    spaceThresholdsHint: 'Կարգավորվում են միայն մուտքերը. ելքը դուրս է բերում շարժիչը՝ ամեն շեմից 5 կետ ցածր, որպեսզի գծի վրա կանգնած պահեստը երբեք մետրոնոմ չդառնա',
    failoverReserveTitle: 'Վթարային փոխարկման պահուստ',
    failoverReserveSubtitle: 'Admission control N+1 — ազատ պահվող RAM, որպեսզի կլաստերը հանգույցներ կորցնելուց հետո կարողանա վերագործարկել իր ծանրաբեռնվածությունը',
    failoverReserveTolerate: 'Քանի հանգույցի կորուստ հանդուրժել',
    failoverReserveOff: '0 — պահուստն անջատված է. ոչ մի գործարկում երբեք չի մերժվում վթարային փոխարկման տարողության պատճառով',
    failoverReserveOn: 'VM-ի գործարկումը, որը կուտեր պահուստը, մերժվում է 412-ով, որը բացատրում է թվերը',
    networkShapingTitle: 'Թողունակության արդարություն',
    networkShapingSubtitle: 'Յուրաքանչյուր uplink-ի shaping ծառի երեք տիպաբանական կշիռները — գործում են միայն մրցակցության դեպքում',
    networkShapingRest: 'Մնացածի կշիռ (կառավարման հարթակ, storage, կրկնօրինակներ)',
    networkShapingOverlay: 'Overlay ցանցերի կշիռ',
    networkShapingLiveMigration: 'Live migration-ի կշիռ',
    networkShapingHint: 'Երաշխավորված բաժին = կշիռ / երեքի գումար (լռելյայն 300 / 100 / 200, յուրաքանչյուրը 1-ից 10000); ազատ կապի դեպքում ցանկացած դաս կարող է վերցնել ամբողջ թողունակությունը',
    debugModeTitle: 'Debug ռեժիմ',
    debugModeSubtitle:
      'Մանրամասն սխալներ GUI-ի ընդհանուր ծանուցումներում — որպեսզի տեսնեք իրական պատճառը, երբ «ձախողված» գործողությունը իրականում հաջողվել է',
    debugModeLabel: 'Debug ռեժիմը միացված է',
    debugModeOn: 'Ընդհանուր սխալի ծանուցումները կցում են հիմքում ընկած պատճառը — ներքին մանրամասները տեսանելի են ամեն օպերատորին',
    debugModeOffHint: 'Անջատված — ընդհանուր սխալի ծանուցումները մնում են ընդհանուր, առանց ներքին մանրամասների',
    nodeDetailsAction: 'Հանգույցի մանրամասներ',
    node: {
      docTitle: 'Հանգույց',
      notFound: 'Հանգույցը չի գտնվել',
      tabOverview: 'Ընդհանուր պատկեր',
      tabStats: 'Վիճակագրություն',
      tabNetwork: 'Ցանց',
      tabSettings: 'Լոկալ կարգավորումներ',
      identityTitle: 'Ինքնություն',
      heartbeatTitle: 'Պուլս',

      // Ռաունդ #156 (ստանդարտ երկխոսություն). ռեգիստրի պոչը, որ մանրամասներին պակասում էր:
      ysqlPort: 'YSQL պորտ',
      revision: 'Կոնֆիգուրացիայի ռևիզիա',
      versionsTitle: 'Դիտարկված տարբերակներ',
      heartbeatSubtitle: 'Վերջինը, ինչ հանգույցը հայտնել է իր մասին',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU մոդել',
      memoryTitle: 'Հիշողություն',
      hugePagesTitle: 'Հսկա էջեր',
      hugePagesPool: '{size}՝ {free} ազատ {total}-ից',
      hugePagesNone: 'Պուլ չկա',
      hugePagesNoneHint: 'Հանգույցը վերապահված հսկա էջեր չունի. դրանք պահանջող VM-ները չեն կարող գործարկվել այստեղ։ Պուլը հայտարարվում է հանգույցի վրա՝ միջուկի hugepagesz և hugepages պարամետրերով կամ nr_hugepages գրելով։',
      usageTitle: 'Ընթացիկ օգտագործում',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'դիտարկված չէ — թարմ նմուշ չկա',
      statsNoData: 'Ընտրված միջակայքում տվյալներ չկան — հանգույցի շարքերը նմուշառվում են հենց հանգույցի կողմից և մատուցվում լոկալ։',
      observedTitle: 'Դիտարկված վիճակ',
      observedSubtitle: 'Ծառայություններ և հանգույցի լոկալ ակտիվներ, ինչպես տեսնում է վորկերը'
    },
    editRolesTitle: 'Խմբագրել ցանցային դերերը',
    memberNode: 'Հանգույց',
    memberIp: 'IP հասցե',
    addMember: 'Ավելացնել անդամ',
    lmInherit: 'Օգտագործել management հասցեները',
    roleIpHint: 'Անդամներ ավելացնելն ու հեռացնելն ազատ է. գոյություն ունեցող անդամի IP-ն տեղում փոխելը մերժվում է — IP-ի միգրացիայի հոսքը գալիս է ավելի ուշ ռաունդով։',
    roleError: 'Չհաջողվեց թարմացնել դերերը',
    nodesTitle: 'Հանգույցներ',
    addNodeTitle: 'Ավելացնել հանգույց կլաստերին',
    addNode: 'Ավելացնել հանգույց',
    addNodeError: 'Չհաջողվեց նախագրանցել հանգույցը',
    nodeName: 'Հանգույցի անուն',
    nodeNameHint: 'պետք է համընկնի տեղադրման ժամանակ ընտրված անվան հետ',
    nodeIp: 'Management IP',
    colName: 'Անուն',
    colPhase: 'Փուլ',
    colServices: 'Ծառայություններ',
    colWatermark: 'Watermark',
    colLastSeen: 'Վերջին կապը',
    colUps: 'UPS',
    upsCordonChip: 'UPS կորդոն',
    upsCordonTip: 'Հանգույցն ինքն իրեն դատապարտել է իր UPS-ի փաստերի հիման վրա ({time}). կորդոնն ինքն է հանում, երբ ցանցը կայուն է, իսկ մարտկոցը՝ լիցքավորված',
    upsUnreachable: 'UPS անհասանելի է',
    upsOnBattery: 'Մարտկոցով',
    upsOnLine: 'Ցանցով',
    upsLowBattery: 'ցածր լիցք',
    upsNoEstimateChip: 'ինքնավարությունը գնահատված չէ',
    upsNoEstimateTip: 'UPS-ը չի հրապարակում ինքնավարության գնահատում. հանգույցը դատապարտվում է միայն UPS-ի LB (ցածր լիցք) դրոշով — կարգավորեք battery.runtime.low / LB հենց UPS-ի վրա',
    upsLaneTip: 'UPS անջատման ուղի {since}-ից. դատապարտված է {by}-ով',
    upsUnit: 'միավոր',
    upsStatus: 'NUT վիճակ',
    upsLoad: 'բեռնվածություն',
    upsOnBatterySince: 'մարտկոցով սկսած',
    upsOnLineSince: 'ցանցով սկսած',
    upsError: 'սխալ',
    upsObservedAt: 'դիտարկված',
    upsNone: 'ոչ մի UPS միավոր չի սպասարկում այս հանգույցը',
    upsBy: {
      runtime: 'ինքնավարությունը շեմից ցածր է',
      lowBattery: 'UPS-ի LB դրոշ',
    },
    upsLane: {
      evacuate: 'տարհանում',
      local: 'անջատում տեղում',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'հյուրերի կանգնեցում',
      stoppingServices: 'ծառայությունների կանգնեցում',
      poweredOff: 'անջատված',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS միավորներ և շեմեր. հանգույցը դատապարտվում է ինքնավարություն ≤ շեմ կամ LB դրոշի դեպքում (միշտ հարգված), վերսկսում հիստերեզիսով',
    upsRuntimeThreshold: 'Ինքնավարության շեմ (վ)',
    upsRuntimeThresholdHint: 'Մարտկոցով, գնահատված ինքնավարություն ≤ շեմ դեպքում հանգույցն անջատվում է հերթականությամբ (լռելյայն 300)',
    upsResumeStable: 'Ցանցը կայուն է (վ)',
    upsResumeStableHint: 'Վերսկսում միայն առնվազն այսքան վայրկյան անընդհատ ցանցի դեպքում (լռելյայն 60)',
    upsResumeCharge: 'Նվազագույն լիցք վերսկսելիս (%)',
    upsResumeChargeHint: 'Եվ մարտկոցը լիցքավորված է առնվազն մինչև այս տոկոսը (լռելյայն 25)',
    upsPolicyNote: 'UPS-ի LB (ցածր լիցք) դրոշը միշտ դատապարտում է և չի անջատվում. մարտկոցով անցկացրած ժամանակի շեմ չկա: Յուրաքանչյուր միավոր կարող է վերասահմանել երեք թվերը:',
    upsUnitNew: 'նոր միավոր',
    upsUnitSelectors: '{n} պիտակի ընտրիչ (միայն CLI)',
    upsUnitName: 'Միավորի անուն',
    upsUnitMode: 'Ռեժիմ',
    upsModeExternal: 'արտաքին (ուրիշի upsd)',
    upsModeManaged: 'կառավարվող (հանգույցին միացված UPS)',
    upsUnitUpsname: 'NUT անուն (upsname)',
    upsUnitHost: 'upsd հոսթ',
    upsUnitAttachedNode: 'Միացված հանգույց',
    upsUnitDriver: 'NUT դրայվեր',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Դրայվերի սարք',
    upsUnitDeviceHint: 'ups.conf-ի port= տողը. դատարկ = auto',
    upsUnitPort: 'upsd պորտ',
    upsUnitServedNodes: 'Սպասարկվող հանգույցներ',
    upsUnitServedNodesHint: 'հանգույցների անուններ՝ ստորակետով բաժանված (պիտակի ընտրիչներն անցնում են CLI-ով)',
    upsUnitOverrideHint: 'դատարկ = կլաստերի լռելյայն',
    upsUnitAdd: 'Ավելացնել միավոր',
    unreachableSince: 'Անհասանելի — վերջին պուլսը {time}',
    overlaysChip: 'օվերլեյներ',
    overlaysBehind: 'Օվերլեյ dataplane-ը դեռ չի իրագործել ընթացիկ օվերլեյ կոնֆիգուրացիան',
    overlaysError: 'Օվերլեյի հաշտեցման վերջին անցումը ձախողվեց՝ {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Միանալու սպասում',
      'joining': 'Միանում է',
      'member': 'Անդամ'
    },
    tokenTitle: 'Միանալու թոքեն',
    tokenOnce: 'Ցուցադրվում է միայն հիմա — անմիջապես պատճենեք, այն այլևս երբեք ընթեռնելի չի լինի',
    copy: 'Պատճենել',
    copied: 'Պատճենված է',
    close: 'Փակել',
    revokeTitle: 'Ետ կանչել նախագրանցումը',
    revoke: 'Ետ կանչել',
    revokeError: 'Չհաջողվեց ետ կանչել գրանցումը',
    promote: 'Դարձնել store-ի անդամ',
    demote: 'Հեռացնել store-ի անդամի դերը',
    troubleshoot: 'Խնդիրների լուծում',
    promoteTitle: 'Դարձնել store-ի անդամ',
    demoteTitle: 'Հեռացնել store-ի անդամի դերը',
    promoteHint: 'Հանգույցը միանում է YugabyteDB master-ների քվորումին։ Իրական HA-ի համար պետք է երեք store-ի անդամ։',
    demoteHint: 'Հանգույցը դուրս է գալիս master-ների քվորումից և կանգնեցնում իր store ծառայությունները։',
    storeError: 'Store-ի անդամի փոփոխությունը մերժվեց',
    attest: 'Հաստատել անջատված լինելը…',
    attestTitle: 'Հաստատել, որ հանգույցն անջատված է',
    attestSubmit: 'Հաստատել անջատված լինելը',
    attestConfirm: 'Դուք հայտարարում եք, որ այս հանգույցն անջատված է՝ ձեր ռիսկով. իրականում կենդանի հանգույցի անջատված լինելը հաստատելը VM-ների կրկնակի աշխատանքի ռիսկ է ստեղծում։ Նրա առաջադրանքները ձախողվում են, և նրա VM-ների պատասխանատվությունը դառնում է փոխանցելի։',
    attestError: 'Հաստատումը մերժվեց',
    attestedChip: 'հաստատված անջատված',
    maintenanceChip: 'սպասարկում',
    guestToolsChip: 'TVirt Guest Tools (հանգույցի լոկալ ISO ակտիվ)',
    maintenanceEnter: 'Միացնել սպասարկումը',
    maintenanceExit: 'Անջատել սպասարկումը',
    maintenanceEnterTitle: 'Միացնել սպասարկումը',
    maintenanceExitTitle: 'Անջատել սպասարկումը',
    maintenanceEnterSubmit: 'Միացնել սպասարկումը',
    maintenanceExitSubmit: 'Անջատել սպասարկումը',
    maintenanceEnterConfirm: 'Հանգույցը մեկուսացվում և դատարկվում է. ցանցային ծառայություններն ու App օրինակները, որոնց authority-ն այն պահում է, փոխանցվում են (օրինակները սառը՝ կանգնեցված և հնձված այստեղ, վերստեղծված նպատակային հանգույցում — ընդհատում), աշխատող VM-ները տեղափոխվում են կենդանի, որտեղ հնարավոր է, այլապես կանգնեցվում են սահուն, ընթացիկ առաջադրանքներն ավարտվում են, նոր աշխատանքը սպասում է, իսկ կանգնեցված VM-ները կորցնում են իրենց authority-ն — Proximity-ն նորից տեղադրում է դրանք հաջորդ գործարկման ժամանակ։ Սպասարկման ավարտին ոչինչ ինքն իրեն չի վերադառնում։',
    maintenanceExitConfirm: 'Հանգույցը վերսկսում է աշխատանք վերցնելը, և Proximity-ն նորից է հաշվի առնում այն տեղաբաշխման համար։ VM-ները վերադառնում են միայն գործարկվելիս։',
    maintenanceError: 'Սպասարկման հարցումը մերժվեց',
    maintenancePlanTitle: 'Տարհանման պլան',
    maintenancePlanLoading: 'Տարհանման պլանի հաշվարկ…',
    maintenancePlanError: 'Չհաջողվեց բեռնել տարհանման պլանը — դատարկումը միևնույն է կմիգրացնի հնարավորի չափով և կկանգնեցնի մնացածը։',
    maintenancePlanEmpty: 'Այս հանգույցում տարհանելու բան չկա — ոչ մի ակտիվ ցանցային ծառայություն, ոչ մի աշխատեցնելու համար պահանջված App օրինակ, ոչ մի աշխատող VM։',
    maintenancePlanSummary: '{migrate} օբյեկտ կտեղափոխվի (VM-ներ, ցանցային ծառայություններ, App օրինակներ), {stop}-ը կկանգնի կամ կմնա տեղում։',
    maintenancePlanReserve_ok: 'Վթարային փոխարկման պահուստը դատարկումից հետո՝ ամբողջական — դեռ {headroom} GiB գործարկելի է՝ հանդուրժելով {n} հանգույցի կորուստ։',
    maintenancePlanReserve_eroded: 'Վթարային փոխարկման պահուստը դատարկումից հետո՝ գրեթե սպառված — {n} հանգույցի խափանման համար ազատ պահվող {reserve} GiB-ից մնում է միայն {headroom} GiB։',
    maintenancePlanReserve_exhausted: 'Վթարային փոխարկման պահուստը դատարկումից հետո՝ ՍՊԱՌՎԱԾ — {n} հանգույցի խափանումը հանդուրժելու համար անհրաժեշտ {reserve} GiB-ից պակասում է {headroom} GiB։ Քանի դեռ այս հանգույցը դուրս է, VM-ների նոր գործարկումները կմերժվեն։',
    maintenancePlanReserve_unknown: 'Վթարային փոխարկման պահուստը դատարկումից հետո՝ հաշվարկելի չէ — մնացած ոչ մի հանգույց չի հայտնել իր հիշողությունը։',
    maintenancePlanReserveHugePages: '{size} չափի հսկա էջերը դատարկումից հետո — ազատ՝ {free} {capacity}-ից, պահանջվում է որպես պահուստ՝ {reserve}։',
    maintenancePlanActionMigrate: 'միգրացվում է',
    maintenancePlanActionMigrateWarning: 'միգրացվում է (փափուկ կանոնը խախտված է)',
    maintenancePlanActionStop: 'կանգնեցվում է',
    maintenancePlanActionBlocked: 'արգելափակված',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'ցանցային ծառայություն',
    maintenancePlanKindApp: 'App օրինակ',
    maintenancePlanColdMove: 'Սառը տեղափոխում. պոդը կանգնեցվում և հնձվում է այստեղ և վերստեղծվում է նպատակային հանգույցում նրա worker-ի կողմից — ընդհատում մինչև նպատակային worker-ի հաջորդ pass-ը։',
    caFingerprint: 'Կլաստերի CA-ի մատնահետք',
    staleChip: 'հնացած',
    troubleshootTitle: 'Store-ի խնդիրների լուծում',
    restartStore: 'Վերագործարկել store ծառայությունները',
    restartHint: 'Եթե store-ը քմահաճություններ է անում, վերագործարկեք նրա ծառայությունները։ Ընդլայնված — օգտագործեք զգուշությամբ։',
    restartQueued: 'Վերագործարկման առաջադրանքը հերթում է',
    restartError: 'Չհաջողվեց վերագործարկել ծառայությունները',
    svcActive: 'ակտիվ',
    svcWanted: 'ցանկալի, բայց չաշխատող',
    svcStopped: 'կանգնեցված',
    noServices: 'Հայտնված ծառայություններ չկան'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Ամբողջ կլաստերի GPU գույքացուցակը՝ խմբավորված ըստ մոդելի — դիտարկված քարտերն ըստ հանգույցի, նշված գրանցումներով և նրանց թեգերով',
    usbTitle: 'USB ռեսուրսներ',
    usbSubtitle: 'Ամբողջ կլաստերի USB գույքացուցակը՝ խմբավորված ըստ մոդելի — դիտարկված սարքերն ըստ հանգույցի, երկու մոդելների գրանցումներով (ըստ սարքի, ըստ պորտի) և նրանց թեգերով',
    markedChip: '{n} օգտագործելի TVirt-ի կողմից',
    orphanChipGpu: '{n} որբացած',
    orphanChipUsb: '{n} որբացած',
    colNode: 'Հանգույց',
    colRegistration: 'Գրանցում',
      noRegsHint: 'Գրանցում չկա — սարքը «օգտագործելի TVirt-ի կողմից» նշվում է հանգույցի երկխոսությունից (Հանգույցներ › հանգույց › Կարգավորումներ)։',
      colDevice: 'Սարք',
      colObserved: 'Դիտարկված',
      colRegs: 'Գրանցումներ',
      regsNone: 'չկա',
      colPci: 'PCIe հասցե',
      colIdentity: 'Ինքնություն / պորտ',
      colClasses: 'Դասեր (թեգեր)',
      colActions: 'Գործողություններ',
      manageOnNode: 'Կառավարեք {node} հանգույցի վրա (նշումն ապրում է հանգույցի երկխոսությունում)',
      introTitle: 'TVirt©-ի կողմից օգտագործելի USB և PCIe սարքերի ամբողջ կլաստերի գույքացուցակը։',
      introStep1: '1. Հանգույցներն ինքնուրույն են հայտնաբերում իրենց GPU-ները և USB սարքերը (հաշվառում պուլսի մեջ)։',
      introStep2: '2. Սարքը «օգտագործելի TVirt-ի կողմից» նշվում է ՀԱՆԳՈՒՅՑԻ երկխոսությունից (Հանգույցներ › հանգույց › Կարգավորումներ) — նշումը կապում է այն vfio-ին և գրանցում այստեղ։',
      introStep3: '3. Այստեղ գրանցումներին տալիս եք նրանց ԴԱՍԵՐԸ թեգերի միջոցով (օր.՝ gpu_class=compute). VM-ների պահանջները դաս կխնդրեն, և պլանավորիչը կընտրի հանգույց՝ ազատ համապատասխան սարքով։',
    colMode: 'Ռեժիմ',
    colState: 'Վիճակ',
    colNotes: 'Նշումներ',
    colTags: 'Թեգեր',
    modeDevice: 'ըստ սարքի',
    modePort: 'ըստ պորտի',
    usable: 'օգտագործելի',
    orphanGpu: 'որբացած',
    orphanUsb: 'որբացած',
    hubChip: 'hub',
    orphanPortsTitle: 'Ըստ պորտի գրանցումներ՝ առանց միացված սարքի — նորից միացրեք սարք կամ ապանշեք դրանք հանգույցից',
    gpusEmpty: 'Ոչ մի հանգույցի վրա դեռ GPU չի դիտարկվել',
    usbEmpty: 'Ոչ մի հանգույցի վրա դեռ USB սարք չի դիտարկվել'
  },

  // Կարգավորումների ձևերի ընդհանուր բառապաշարը (ռեֆակտորինգ 2026-07-24).
  // անվտանգության դաշտերը սնում են Կլաստեր էջի կարգավորումների քարտը, հանգույցի
  // դաշտերը՝ node-settings էջը — /system/settings էջը, որի համար ծնվել էին, մեռած է:
  settings: {
    passwordMinLength: 'Գաղտնաբառի նվազագույն երկարություն',
    sessionIdle: 'Սեանսի անգործության ժամանակահատված (րոպե)',
    lockoutThreshold: 'Արգելափակում ձախողված փորձերից հետո',
    lockoutDuration: 'Արգելափակման տևողություն (րոպե)',
    keyboardLayout: 'Ստեղնաշարի դասավորություն',
    keyboardLayoutHint: 'օր.՝ it, en-us — դատարկ՝ QEMU-ի լռելյայնի համար',
    syslogEndpoint: 'Syslog վերջնակետ',
    syslogEndpointHint: 'հոսթ:պորտ — դատարկ՝ փոխանցումն անջատելու համար',
    syslogTls: 'TLS',
    maxQueued: 'Հերթում առաջադրանքների առավելագույն թիվը',
    concurrency: 'Վորկերի զուգահեռություն',
    concurrencyHint: 'Կիրառվում է վորկերի կողմից անմիջապես',
    notesTitle: 'Նշումներ',
    save: 'Պահպանել',
    saved: 'Կարգավորումները պահպանված են',
    saveError: 'Չհաջողվեց պահպանել կարգավորումները'
  },
  localSettings: {
    derivedChip: 'ածանցյալ',
    derivedTip: 'Այս device-ը fabric-ի ածանցման ՍԵՓԱԿԱՆՈՒԹՅՈՒՆՆ Է (H2). խմբագրիչը հրաժարվում է դիպչել դրան — փոխեք fabric-ը (կամ մալուխավորումը) և կրկին կիրառեք, կամ վերցրեք այն հետ ներքևում։',
    takeOwnership: 'Վերցնել սեփականությունը',
    takeOwnershipTitle: 'Վերցնել սեփականությունը (take-ownership)',
    takeOwnershipConfirm: '{name}-ը դուրս է գալիս fabric բլոկից և նորից դառնում է ՁԵՌՔՈՎ device, որը կառավարում է այս խմբագրիչը։ Հանգույցը դառնում է շեղված, և ածանցման հաջորդ apply-ը կմերժի դրա վրա (manualConflict), մինչև այն վերանվանեք կամ հեռացնեք — կամ ուղղեք fabric-ը։',
    nodeSettingsTitle: 'Հանգույցի կարգավորումներ',
    nodeSettingsSubtitle: 'Ինչ է կիրառում այս հանգույցը — առաջադրանքների հերթ, կոնսոլ, մատյանի փոխանցում — գումարած նրա թեգերն ու նշումները',
    baseTitle: 'Հոսթի պահուստավորումներ (TVirt Proximity)',
    baseSubtitle: 'Հոսթի ՕՀ-ին վերապահված CPU և RAM — էմպիրիկ տարողության մուտքային տվյալները, որով Proximity-ն տեղաբաշխում է VM-ները',
    baseMemory: 'Բազային RAM (MiB)',
    baseMemoryHint: 'Դիտարկված ընդհանուրը՝ {total} MiB։ Օգտագործելի VM-ների համար = ընդհանուր − բազա − այստեղ տեղաբաշխված միացված VM-ների RAM-ը։',
    baseMemoryHintNoTotal: 'Օգտագործելի VM-ների համար = դիտարկված ընդհանուր − բազա − այստեղ տեղաբաշխված միացված VM-ների RAM-ը։',
    baseCpu: 'Բազային CPU միջուկներ',
    baseCpuHint: 'Դիտարկված տրամաբանական CPU-ներ՝ {total}։ Օգտագործվում է միայն որպես դասակարգման կշիռ — vCPU-ների գերբաշխումը նորմալ է։',
    baseCpuHintNoTotal: 'Օգտագործվում է միայն որպես դասակարգման կշիռ — vCPU-ների գերբաշխումը նորմալ է։',
    baseHint: 'RAM-ը ընդունելության կոշտ դարպասն է. VM-ը, որը չի տեղավորվում օգտագործելի RAM-ում, մերժվում է խոսուն սխալով։ Բարձրացրեք բազան այն հոսթերի վրա, որոնք հյուրընկալում են store-ի անդամներ կամ Ceph դեմոններ։',
    placementTitle: 'Ֆիզիկական տեղադրություն',
    placementSubtitle: 'Որտեղ է ֆիզիկապես կանգնած այս սերվերը — հայտարարվում է մեկ անգամ, ինչ էլ որ մատուցի',
    placementHint: 'Տեղադրությունը վարում է այս սերվերի վրա OSD ունեցող ամեն Ceph կլաստերի CRUSH հիերարխիան. փոփոխության պահպանումը վերադասավորում է նրանց քարտեզները առաջադրանքի միջոցով (host → rack → … → root)։ Մասնակի հայտարարությունները օրինական են — դատարկ մակարդակները պարզապես կոլապսվում են։ Անունները կիսվում են ամբողջ քարտեզով. նույն դարակում գտնվող երկու սերվեր հայտարարում են դարակի նույն անունը։',
    placementNameInvalid: 'DNS-անվտանգ անուն (փոքրատառեր, թվանշաններ, գծիկներ)',
    placementEmpty: 'Դատարկ = հայտարարված չէ',
    placementLevel: {
      chassis: 'Շասսի',
      rack: 'Դարակ',
      row: 'Շարք',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Սենյակ',
      datacenter: 'Տվյալների կենտրոն',
      zone: 'Գոտի',
      region: 'Տարածաշրջան'
    },
    cablingTitle: 'Մալուխավորում',
    cablingSubtitle: 'Կոմուտատորի որ պորտին է միացված ամեն ինտերֆեյս — հայտարարությունն ապրում է հանգույցի վրա (Annex O.9)',
    cablingHint: 'Մեկ մալուխ ամեն NIC-ի, մեկ մալուխ ամեն պորտի՝ ամբողջ նավատորմում (API-ն մերժում է՝ նշելով տիրոջը)։ LAGG-ի անդամ պորտին մալուխավորելը օրինական է — դա բոնդի դեպքն է. ապագա ածանցումը կներկայացնի այն որպես LACP։',
    cablingInterface: 'Ինտերֆեյս',
    cablingNotCabled: '— միացված չէ —',
    cablingNoInterfaces: 'Ցանցային ինտերֆեյսներ դեռ չեն դիտարկվել',
    disksTitle: 'Սկավառակներ',
    disksSubtitle: 'Դիտարկված բլոկային սարքեր — մեկ սկանավորում ամեն հաշտեցման անցումով. այստեղ նշեք Ceph OSD-ի համար օգտագործելի սկավառակները (N.15՝ իրավասությունը բացահայտ է)',
    colDataDisk: 'Տվյալների սկավառակ',
    dataDisksHint: 'Սարքը նշելը հայտարարում է այն օգտագործելի որպես OSD. սերիան նրա ինքնության ամրացումն է — պատճենվում է սարքաշարից, երբ սարքը հայտնում է այն, հակառակ դեպքում՝ գեներացվում (tvirt-…)։ Ceph-ի գրանցման երկխոսությունն առաջարկում է միայն հայտարարված սկավառակները։',
    diskDeclaredSerial: 'հայտարարված',
    diskNotObserved: 'հայտարարված, բայց չդիտարկված — նորից ամրացրեք սարքը կամ ապանշեք այն',
    noDisks: 'Բլոկային սարքեր դեռ չեն դիտարկվել',
    colSerial: 'Սերիա',
    colModel: 'Մոդել',
    colSize: 'Չափ (GiB)',
    colDiskType: 'Տեսակ',
    colInUse: 'Օգտագործման մեջ',
    colObservedAt: 'Դիտարկված',
    diskInUse: 'օգտագործման մեջ',
    diskFree: 'ազատ',
    diskMounted: 'միակցված',
    diskPartitions: 'բաժիններ',
    passthroughTitle: 'Ուղիղ փոխանցման սարքեր',
    passthroughSubtitle: 'Դիտարկված GPU-ներ և USB սարքեր — այստեղ նշեք, թե ինչ կարող է TVirt-ը փոխանցել VM-ներին. նշումը գրանցում է սարքի ինքնությունը (ռաունդ U1+G1)',
    passthroughHint: 'Նշումը գրանցում է սարքը (կայուն id — թեգերի և դասի պահանջների թիրախը)։ Նշված GPU-ի ԱՄԲՈՂՋ IOMMU խումբը միանգամից կապվում է vfio-pci-ին — այն անմիջապես լքում է հոսթը. ապանշումը վերակապում է բնիկ դրայվերը։ USB-ի համար կան երկու վավերացված մոդելները. ըստ սարքի (vendor+product, որտեղ էլ միացված լինի) և ըստ ֆիզիկական պորտի (VM-ին հասնում է այն, ինչ միացված է այնտեղ)։ USB-ն նշման պահին երբեք չի կապվում — կցումը կատարվում է VM-ի աշխատանքի ժամանակ։',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Օգտագործելի TVirt-ի կողմից',
    colGpu: 'GPU',
    colPciAddress: 'PCI հասցե',
    colDriver: 'Դրայվեր',
    colVerdict: 'Վճիռ',
    gpuEligible: 'Իրավասու',
    gpuIneligible: 'Ոչ իրավասու',
    gpuReason: {
      'no-iommu': 'IOMMU-ն ակտիվ չէ հոսթի վրա',
      'group-spans-slots': 'IOMMU խումբը մեկուսացված չէ. այն ձգվում է այլ սլոթերի վրա',
      'multiple-display': 'IOMMU խումբը մեկուսացված չէ. մեկից ավելի էկրանային ֆունկցիա',
      'foreign-function': 'IOMMU խումբը մեկուսացված չէ. այն պարունակում է օտար ֆունկցիա'
    },
    vfioNotReady: 'IOMMU-ն ակտիվ չէ այս հոսթի վրա. ոչ մի GPU իրավասու չէ, մինչև հոսթի պլատֆորմը միացնի այն (OEM ISO) — TVirt-ը երբեք չի շտկում միջուկի արգումենտները աշխատանքի ընթացքում։',
    vfioMissingKernelArg: 'IOMMU-ն ակտիվ չէ այս հոսթի վրա. որոնվածքը հայտնում է VT-d/AMD-Vi (ACPI DMAR/IVRS աղյուսակը կա), բայց միջուկի արգումենտը բացակայում է — ավելացրեք intel_iommu=on (Intel) կամ հանեք amd_iommu=off (AMD) միջուկի հրամանի տողից և վերագործարկեք։ TVirt-ը երբեք չի շտկում միջուկի արգումենտները աշխատանքի ընթացքում։',
    vfioFirmwareDisabled: 'IOMMU-ն ակտիվ չէ այս հոսթի վրա. VT-d/AMD-Vi-ն անջատված է որոնվածքում (ACPI DMAR/IVRS աղյուսակ չկա), կամ CPU-ն այն չի աջակցում — միացրեք այն որոնվածքի կարգավորումներում. ոչ մի միջուկի արգումենտ չի կարող միացնել այն։ TVirt-ը երբեք չի շտկում հոսթը աշխատանքի ընթացքում։',
    gpuBindError: 'vfio-pci կապումը ձախողվեց {address}-ի վրա՝ {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Ֆայրվոլ չկառավարվող կամուրջների վրա',
    firewallBridgesSubtitle: 'Այս հանգույցի վրա ձեռքով կառուցված կամուրջները, որոնց setup-ը համաձայնում է կցված հյուրի NIC-երի վրա TVirt-ի գեներացրած ֆայրվոլի chain-երին',
    firewallBridgesHint: 'TVirt-ը երբեք չի դիպչում օտար կամրջին — chain-ը խարսխվում է tap/veth-ի վրա, որը միշտ TVirt-ինն է։ Ցուցակը համաձայնության դարպաս է. default-deny-ն և anti-spoof-ը կարող են կոտրել այն, ինչ ձեռքով արված setup-ը սպասում է, ուստի այստեղ ՉԹՎԱՐԿՎԱԾ չկառավարվող կամրջի վրա ֆայրվոլ կրող NIC-ը մերժվում է խոսուն սխալով։',
    firewallBridgesEmpty: 'Այս հանգույցում ոչ մի չկառավարվող կամուրջ չի համաձայնում TVirt-ի գեներացրած ֆայրվոլի chain-երին։',
    firewallBridgeAdd: 'Ավելացնել կամուրջ',
    firewallBridgeInvalid: 'Linux ինտերֆեյսի անուն չէ (1-15 նիշ, առանց շեղագծի և բացատի)',
    firewallBridgeDuplicate: 'Անունն արդեն ցուցակում է',
    colMarkDevice: 'Ըստ սարքի',
    colMarkPort: 'Ըստ պորտի',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Պորտ',
    passthroughOrphan: 'որբացած — գրանցված, բայց այլևս չհայտնաբերվող. նորից միացրեք կամ ապանշեք այն',
    noGpus: 'GPU-ներ դեռ չեն դիտարկվել',
    noUsb: 'USB սարքեր դեռ չեն դիտարկվել',
    networkGeneration: 'Ցանցի սերունդ',
    applied: 'Կիրառված',
    converged: 'զուգամիտված',
    behind: 'հետ է — {m} / {n}',
    notConfigured: 'կարգավորված չէ',
    rollbackBody: '{gen} սերնդի կիրառումը ձախողվեց՝ {error}',
    rolledBackChip: 'ետադարձ կատարված',
    nicsTitle: 'NIC-եր',
    nicsSubtitle:
      'Կառավարվող NIC-երի հաշվառումը — գրանցումը ՀԵՆՑ կառավարման հայտարարությունն է. գրանցված NIC-ին առանց կոնֆիգուրացիայի չեն դիպչում (clear-if-ը բացահայտորեն հայտարարում է այն մաքուր), չգրանցված սարքին երբեք չեն դիպչում',
    addNic: 'Գրանցել NIC',
    addNicTitle: 'Գրանցել NIC (add-nic)',
    delNic: 'Ավարտել կառավարումը',
    delNicTitle: 'Ավարտել կառավարումը (del-nic)',
    delNicConfirm:
      '{name}-ի կառավարումն ավարտվում է. հաշվառման գրառումը և նրա կոնֆիգուրացիան ջնջվում են, TVirt պրոֆիլը հեռացվում է — սարքն ինքը մնում է այնպես, ինչպես Linux-ն ունի այն։',
    nicName: 'Սարքի անուն',
    nicMac: 'Մշտական MAC հասցե',
    nicMacHint: 'մշտական սարքաշարային MAC-ը — TVirt Server Installer-ի սահմանած կայուն ինքնությունը',
    colObserved: 'Դիտարկված',
    nicObserved: 'դիտարկված',
    nicNotObserved: 'չդիտարկված',
    nicMacMismatch: 'MAC-ի անհամապատասխանություն — դիտարկված է {mac}',
    noNics: 'Գրանցված NIC-եր չկան — գրանցեք սարք՝ այն կառավարել սկսելու համար',
    noManagedDevices: 'Կառավարվող սարքեր չկան — նախ գրանցեք NIC. ամեն ինչ կառուցվում է հաշվառման վրա',
    inventoryTitle: 'Դիտարկված սարքեր',
    inventorySubtitle: 'Թարմացվում են ամեն հաշտեցման անցումով հանգույցի վորկերի կողմից — վալիդացիան ստուգում է սարքերի անունները այս գույքացուցակի վրա',
    colDevice: 'Սարք',
    colType: 'Տեսակ',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Արագություն',
    colTopology: 'Տոպոլոգիա',
    colMtu: 'MTU',
    colAddresses: 'Հասցեներ',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP-ը չի ագրեգացնում',
    noInventory: 'Սարքեր դեռ չեն հայտնվել',
    interfacesTitle: 'Ինտերֆեյսներ',
    interfacesSubtitle:
      'Գրանցված NIC-երի և հայտարարված տրամաբանական սարքերի L3 կոնֆիգուրացիան — set-if-ը փոխարինում է ամբողջ բլոկը, edit-if-ը շտկում է հատկությունները, clear-if-ը դատարկում է այն (բացահայտ մաքրություն)',
    colConfig: 'Ցանկալի կոնֆիգուրացիա',
    clean: 'մաքուր',
    setIf: 'Խմբագրել հասցեավորումը',
    setIfTitle: 'Խմբագրել հասցեավորումը (set-if)',
    editIf: 'Խմբագրել հատկությունները',
    editIfTitle: 'Խմբագրել հատկությունները (edit-if)',
    clearIf: 'Դատարկել կոնֆիգուրացիան',
    clearIfTitle: 'Դատարկել կոնֆիգուրացիան (clear-if)',
    clearIfConfirm: 'Ինտերֆեյսի կոնֆիգուրացիան դատարկվում է։ Մաքուր ինտերֆեյսը նախապայման է՝ այն որպես բոնդի/կամրջի անդամ կամ VLAN-ի ծնող ենթարկելու համար։',
    ip4Mode: 'IPv4 ռեժիմ',
    ip6Mode: 'IPv6 ռեժիմ',
    modeUnconfigured: 'Կարգավորված չէ',
    modeStatic: 'Ստատիկ',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4 հասցեներ',
    ip6Addresses: 'IPv6 հասցեներ',
    addressesHint: 'CIDR, ստորակետով բաժանված',
    gw4: 'IPv4 դարպաս',
    gw6: 'IPv6 դարպաս',
    dns: 'DNS սերվերներ',
    dnsHint: 'ստորակետով բաժանված — դատարկը զրոյացնում է DNS-ը (set-if-ը փոխարինում է բլոկը)',
    routes4: 'IPv4 ստատիկ երթուղիներ',
    routes6: 'IPv6 ստատիկ երթուղիներ',
    routeTo: 'Նշանակետ (CIDR)',
    routeVia: 'Միջոցով',
    addRoute: 'Ավելացնել երթուղի',
    routesChip: 'երթուղիներ',
    mtu: 'MTU',
    mtuHint: 'դատարկ = դրայվերի լռելյայնը',
    vlansTitle: 'VLAN-ներ',
    addVlan: 'Ավելացնել VLAN',
    addVlanTitle: 'Ավելացնել VLAN (add-vlan)',
    delVlanTitle: 'Ջնջել VLAN (del-vlan)',
    vlanParent: 'Ծնող ինտերֆեյս',
    vlanId: 'VLAN ID',
    vlanPreview: 'Սարքի անուն',
    colParent: 'Ծնող',
    colVlanId: 'ID',
    noVlans: 'Հայտարարված VLAN-ներ չկան',
    bondsTitle: 'Բոնդեր',
    addBond: 'Ավելացնել բոնդ',
    addBondTitle: 'Ավելացնել բոնդ (add-bond)',
    editBondTitle: 'Խմբագրել բոնդը',
    editBond: 'Պահպանել բոնդը',
    delBondTitle: 'Ջնջել բոնդ (del-bond)',
    bondName: 'Բոնդի անուն',
    members: 'Անդամներ',
    membersHint: 'անդամները պետք է լինեն մաքուր ինտերֆեյսներ (առանց L3 կոնֆիգուրացիայի)',
    bondMode: 'Ռեժիմ',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Առաջնային անդամ',
    rate: 'LACP տեմպ',
    hash: 'Փոխանցման հեշի քաղաքականություն',
    colMembers: 'Անդամներ',
    colMode: 'Ռեժիմ',
    noBonds: 'Հայտարարված բոնդեր չկան',
    bridgesTitle: 'Կամուրջներ',
    addBridge: 'Ավելացնել կամուրջ',
    addBridgeTitle: 'Ավելացնել կամուրջ (add-bridge)',
    editBridgeTitle: 'Խմբագրել կամուրջը',
    editBridge: 'Պահպանել կամուրջը',
    delBridgeTitle: 'Ջնջել կամուրջ (del-bridge)',
    bridgeName: 'Կամրջի անուն',
    stp: 'STP',
    stpOn: 'STP միացված',
    stpOff: 'STP անջատված',
    colStp: 'STP',
    noBridges: 'Հայտարարված կամուրջներ չկան',
    hostnameTitle: 'Հոսթի անուն',
    hostname: 'Հոսթի անուն',
    setHostname: 'Սահմանել հոսթի անունը',
    setHostnameTitle: 'Սահմանել հոսթի անունը (set-hostname)',
    hostnameHint: 'Միայն ՕՀ-ի ինքնությունը — կլաստերում հանգույցի անունը չի դիպչվում',
    notSet: 'սահմանված չէ',
    staticHostsTitle: 'Ստատիկ host գրառումներ',
    addStaticHost: 'Ավելացնել գրառում',
    addStaticHostTitle: 'Ավելացնել ստատիկ host գրառում',
    delStaticHostTitle: 'Ջնջել ստատիկ host գրառումը',
    hostIp: 'IP հասցե',
    hostNames: 'Անուններ',
    hostNamesHint: 'ստորակետով կամ բացատով բաժանված',
    colIp: 'IP',
    colNames: 'Անուններ',
    noStaticHosts: 'Ստատիկ host գրառումներ չկան',
    delConfirm: '{name}-ը հեռացվում է ցանկալի փաստաթղթից — հանգույցի վորկերը զուգամիտում է NetworkManager-ի checkpoint-ով և ավտոմատ ետադարձով։',
    remove: 'Հեռացնել',
    opError: 'Ցանցային գործողությունը մերժվեց'
  }
}
